<template>
  <layout>
    <q-card class="flexbox">
      <div class="profile-header">
        <div class="profile-header-title" style="color:#000;font-weight:700">Custom Tag</div>
        <div class="profile-header-icons">
          <q-btn color="red" round @click="$store.commit('tag/SET_ADD',true)">
            <q-icon color="white" name="fas fa-plus" size="15px" class="cursor-pointer"></q-icon>
          </q-btn>
        </div>
      </div>
      <div class="content">
        <loading v-if="loading && tags.length === 0"></loading>
        <empty-value
          v-else-if="!loading && tags.length === 0"
          style="background:#fff !important"
          description="If you want to add manual please hit the button."
          name="record"
        ></empty-value>
        <transition-group tag="div" name="list" class="tag-container" v-else>
          <tag v-for="tag in tags" :key="tag.id" :tag="tag"></tag>
        </transition-group>
        <tag-edit></tag-edit>
        <tag-delete></tag-delete>
        <tag-add></tag-add>
      </div>
    </q-card>
  </layout>
</template>

<script>
import TagEdit from "../components/TagEdit";
import TagAdd from "../components/TagAdd";
import TagDelete from "../components/TagDelete";
import Layout from "../components/Layout";
import Tag from "../components/Tag";
import Loading from "../components/Loading";
import axios from "../axios";
import EmptyValue from "../components/EmptyValue";
export default {
  metaInfo() {
    return {
      title:
        "Customize Tag / Flag options | FMS",
      meta: [
        {
          name: "description",
          content: " Customize Tag / Flag options",
        },
        {
          property: "og:title",
          content:
            " Customize Tag / Flag options | FMS",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  components: {
    Layout,
    Tag,
    TagAdd,
    TagDelete,
    Loading,
    EmptyValue,
    TagEdit,
  },
  computed: {
    tags: {
      get() {
        return this.$store.state.tag.tags;
      },
      set(val) {
        this.$store.commit("tag/SET_TAGS", val);
      },
    },
    loading: {
      get() {
        return this.$store.state.tag.loading;
      },
      set(val) {
        this.$store.commit("tag/SET_LOADING", val);
      },
    },
  },
  async mounted() {
    this.$store.state.tag.tags.length === 0 ? await this.getTags() : "";
  },
  methods: {
    async getTags() {
      try {
        this.loading = true;
        const { data } = await axios.get("vehicle-tags");
        this.tags = data.data;
        this.loading = false;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.list-enter-active,
.list-leave-active {
  transition: all 500ms;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.tag-container {
  display: flex;
  flex-flow: column nowrap;
}
</style>
